import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-cancel-schedule',
  templateUrl: './info-cancel-schedule.component.html',
  styleUrls: ['./info-cancel-schedule.component.css']
})
export class InfoCancelScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
